import { styled } from '@mui/material';

export const AppErrorMessageRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
});
